import {DataTestAttrs, getTestProps} from '@benchling/js-test-utils';
import {createStyles} from '@mantine/core';
import classNames from 'classnames';
import React from 'react';
import {ControlButton} from 'reactflow';

import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export interface BaseControlButtonProps {
  icon: BenchlingIconName;
  tooltip?: string;
  onClick: () => void;
  disabled?: boolean;
  'aria-label'?: string;
  dataTestAttrs?: DataTestAttrs;
}

/**
 * Control button for use in <HorizontalControls>, which provides consistent styling.
 */
const useStyles = createStyles(() => ({
  controlButton: {
    borderBottom: 'none',
    borderRadius: '4px',
    margin: '2px',
  },
}));

export default function BaseControlButton({
  icon,
  tooltip,
  onClick,
  disabled,
  'aria-label': ariaLabel,
  dataTestAttrs,
}: BaseControlButtonProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <Tooltip text={tooltip} isDisabled={tooltip == null}>
      <ControlButton
        className={classNames('react-flow__controls-button', classes.controlButton)}
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel ?? tooltip}
        {...getTestProps(dataTestAttrs)}
      >
        <BenchlingIcon icon={icon} />
      </ControlButton>
    </Tooltip>
  );
}
